import React from 'react';
import Slider from 'react-slick';
import ReactPlayer from 'react-player';

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="27"
        viewBox="0 0 40 27"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.222092 13.6779C0.222092 13.302 0.369003 12.9415 0.630516 12.6757C0.892029 12.4099 1.24672 12.2606 1.61655 12.2606H34.5063L25.7296 3.34256C25.5999 3.21078 25.4971 3.05433 25.4269 2.88215C25.3568 2.70997 25.3207 2.52543 25.3207 2.33907C25.3207 2.1527 25.3568 1.96816 25.4269 1.79598C25.4971 1.62381 25.5999 1.46736 25.7296 1.33558C25.8592 1.2038 26.0132 1.09927 26.1826 1.02795C26.352 0.956629 26.5335 0.919922 26.7169 0.919922C26.9002 0.919922 27.0818 0.956629 27.2512 1.02795C27.4206 1.09927 27.5745 1.2038 27.7042 1.33558L38.8599 12.6744C38.9897 12.8061 39.0927 12.9625 39.163 13.1347C39.2333 13.3069 39.2695 13.4915 39.2695 13.6779C39.2695 13.8643 39.2333 14.0489 39.163 14.2211C39.0927 14.3933 38.9897 14.5497 38.8599 14.6814L27.7042 26.0202C27.5745 26.152 27.4206 26.2566 27.2512 26.3279C27.0818 26.3992 26.9002 26.4359 26.7169 26.4359C26.5335 26.4359 26.352 26.3992 26.1826 26.3279C26.0132 26.2566 25.8592 26.152 25.7296 26.0202C25.5999 25.8885 25.4971 25.732 25.4269 25.5598C25.3568 25.3877 25.3207 25.2031 25.3207 25.0168C25.3207 24.8304 25.3568 24.6458 25.4269 24.4737C25.4971 24.3015 25.5999 24.145 25.7296 24.0133L34.5063 15.0953H1.61655C1.24672 15.0953 0.892029 14.9459 0.630516 14.6801C0.369003 14.4143 0.222092 14.0538 0.222092 13.6779Z"
          fill="white"
        />
      </svg>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="27"
        viewBox="0 0 40 27"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.8326 13.6779C39.8326 13.302 39.6857 12.9415 39.4242 12.6757C39.1627 12.4099 38.808 12.2606 38.4381 12.2606H5.54834L14.3251 3.34256C14.4547 3.21078 14.5576 3.05433 14.6278 2.88215C14.6979 2.70997 14.734 2.52543 14.734 2.33907C14.734 2.1527 14.6979 1.96816 14.6278 1.79598C14.5576 1.62381 14.4547 1.46736 14.3251 1.33558C14.1954 1.2038 14.0415 1.09927 13.8721 1.02795C13.7027 0.956629 13.5212 0.919922 13.3378 0.919922C13.1545 0.919922 12.9729 0.956629 12.8035 1.02795C12.6341 1.09927 12.4802 1.2038 12.3505 1.33558L1.19483 12.6744C1.06497 12.8061 0.96194 12.9625 0.891641 13.1347C0.821342 13.3069 0.785156 13.4915 0.785156 13.6779C0.785156 13.8643 0.821342 14.0489 0.891641 14.2211C0.96194 14.3933 1.06497 14.5497 1.19483 14.6814L12.3505 26.0202C12.4802 26.152 12.6341 26.2566 12.8035 26.3279C12.9729 26.3992 13.1545 26.4359 13.3378 26.4359C13.5212 26.4359 13.7027 26.3992 13.8721 26.3279C14.0415 26.2566 14.1954 26.152 14.3251 26.0202C14.4547 25.8885 14.5576 25.732 14.6278 25.5598C14.6979 25.3877 14.734 25.2031 14.734 25.0168C14.734 24.8304 14.6979 24.6458 14.6278 24.4737C14.5576 24.3015 14.4547 24.145 14.3251 24.0133L5.54834 15.0953H38.4381C38.808 15.0953 39.1627 14.9459 39.4242 14.6801C39.6857 14.4143 39.8326 14.0538 39.8326 13.6779Z"
          fill="white"
        ></path>
      </svg>
    </div>
  );
}

function VideoCustomPaging({ videos }) {
  const settings = {
    customPaging: (i) => (
      <a>
        <img src={getVideoThumbnail(videos[i])} alt={`Thumbnail ${i}`} />
      </a>
    ),
    dots: videos?.length > 1,
    dotsClass: 'slick-dots slick-thumb',
    speed: 500,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: videos?.length > 1 && <SampleNextArrow />,
    prevArrow: videos?.length > 1 && <SamplePrevArrow />,
  };

  const getVideoThumbnail = (url) => {
    const isYouTube = url.includes('youtu');
    const isVimeo = url.includes('vimeo');

    if (isYouTube) {
      const match = url.match(
        /(?:youtu\.be\/|(?:\?.*v=|\/embed\/|\/shorts\/))([a-zA-Z0-9_-]+)/
      );
      const videoId = match ? match[1] : null;
      return videoId ? `https://img.youtube.com/vi/${videoId}/0.jpg` : null;
    }

    if (isVimeo) {
      const match = url.match(/vimeo\.com\/(\d+)/);
      const videoId = match ? match[1] : null;
      if (videoId) {
        return `https://vumbnail.com/${videoId}.jpg`;
      }
    }

    return null; // Fallback if no match
  };

  return (
    <>
      <div className="slider-container">
        <Slider {...settings}>
          {videos?.length &&
            videos?.map((url, index) => {
              return (
                <div className="h-80" key={index}>
                  <ReactPlayer
                    className="react-player"
                    controls
                    url={url}
                    width="100%"
                    height="100%"
                  />
                </div>
              );
            })}
        </Slider>
      </div>
    </>
  );
}

export default VideoCustomPaging;
